import { useEffect } from "react";

const SmoothScroll: React.FC = () => {
  useEffect(() => {
    // Add smooth scrolling to the page
    document.documentElement.style.scrollBehavior = "smooth";

    // Improve anchor link scrolling
    const handleLinkClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const link = target.closest("a");

      if (link && link.hash && link.hash.length > 1) {
        e.preventDefault();
        const targetElement = document.querySelector(link.hash);
        if (targetElement) {
          const navbarHeight = document.querySelector(".header")?.clientHeight || 0;
          const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - navbarHeight - 20;

          window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
          });
        }
      }
    };

    document.addEventListener("click", handleLinkClick);

    return () => {
      document.removeEventListener("click", handleLinkClick);
      document.documentElement.style.scrollBehavior = "";
    };
  }, []);

  return null;
};

export default SmoothScroll;
